import * as React from 'react';
import PageTitle from "../../api/PageTitle";
import "./doctor.css";
import DocMain from "./DocMain";

const DoctorHome = () => {
  return (
    <>
      <PageTitle name="Doctor's List" link="Home" page="Doctor" />
      <DocMain />
      

     
    </>
  );
};

export default DoctorHome;
